import { QUESTION_TYPES } from '@api/instant_survey';
import type { Question } from '@api/instant_survey/types';
import { Card, InfoFilledIcon, RadioButtonIcon } from '@utilities';

import styles from './_index.module.scss';

interface PreviewViewProps {
  previewQuestion: Question;
}

const getQuestionTypeLabel = (type: string) => {
  if (type === QUESTION_TYPES.RADIO.value) return QUESTION_TYPES.RADIO.name;
  return type;
};

const PreviewView = ({ previewQuestion }: PreviewViewProps) => (
  <>
    <div className={styles['preview-view-banner']}>
      <InfoFilledIcon />
      <span>
        <strong>This is a preview for a Numerator screener.</strong> Screener questions have limited
        edits and do not count toward your total.
      </span>
    </div>
    <Card className={styles['preview-view-card']} padding="large">
      <span className={styles['preview-view-type']}>
        S1 · {getQuestionTypeLabel(previewQuestion.type).toUpperCase()}
      </span>
      <p>{previewQuestion.text}</p>
      <div className={styles['preview-view-answers']}>
        {previewQuestion.answers.map(({ text }, index) => (
          <span key={`${text}-${index}`}>
            <RadioButtonIcon />
            {text}
          </span>
        ))}
      </div>
    </Card>
  </>
);

export default PreviewView;
